import { FC } from "react";
import { PageHeader } from "../../components/PageHeader";
import { Environments } from "../../modules/Environments";
import "./style.css";

export const EnvironmentsPage: FC = () => {
  return (
    <div className="environments-page">
      <PageHeader
        header="List of environments"
        description="Click on list label to sort by clicked label"
      />
      <Environments />
    </div>
  );
};
